import { createClient } from "next-sanity";
import { isProduction } from "~www/utils/is-production";
import { apiVersion, dataset, projectId, studioUrl } from "./env";

// only the client should go in this file
// other helpers are in ./sanity-helpers.ts
export const sanityClient = createClient({
  apiVersion,
  dataset,
  perspective: "published",
  projectId,
  stega: {
    studioUrl,
  },
  useCdn: isProduction(),
});
